import { SOGetProcess } from '../process/so-get-process';
import { SOGetStep } from '../step/so-get-step';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {ENProcessStepType} from '../../enums';


export class SOPutProcessStepAssociation {

  constructor(
    public uid: string,
    public name: string = null,
    public processStepType: ENProcessStepType = null,
    public process: SOGetProcess = null,
    public step: SOGetStep = null,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutProcessStepAssociation(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'processStepType' in params ? params.processStepType : null,
      'process' in params ? params.process : null,
      'step' in params ? params.step : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
